/* eslint-disable no-template-curly-in-string */
import { number, object, SchemaOf } from 'yup';

import { MUST_BE_INTEGER, MUST_BE_NUMBER, REQUIRED_FIELD } from '@/config/text.const';
import { getBillingIntervals } from '@/utils/data-helpers/intervals';

export type Fields = {
  Annual: number | string;
  HalfYearly: number | string;
  Quarterly: number | string;
  Monthly: number | string;
};

const minValueMessage = 'The minimum value is ${min}';

const validateMaxValue = (value: number | undefined, context: any, field: string) => {
  const interval = getBillingIntervals().find((el) => el.billingInterval === field);
  if (!interval) {
    return true;
  }

  if (typeof value === 'undefined' || value > interval.globalDBRLimit.maxDays) {
    return context.createError({
      path: field,
      message: `Value must be less than or equal to ${interval.globalDBRLimit.maxDays}`,
    });
  }

  return true;
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  Annual: number()
    .typeError(MUST_BE_NUMBER)
    .min(0, minValueMessage)
    .integer(MUST_BE_INTEGER)
    .test((value, context) => validateMaxValue(value, context, 'Annual'))
    .required(REQUIRED_FIELD),

  HalfYearly: number()
    .typeError(MUST_BE_NUMBER)
    .min(0, minValueMessage)
    .integer(MUST_BE_INTEGER)
    .test((value, context) => validateMaxValue(value, context, 'HalfYearly'))
    .required(REQUIRED_FIELD),

  Quarterly: number()
    .typeError(MUST_BE_NUMBER)
    .min(0, minValueMessage)
    .integer(MUST_BE_INTEGER)
    .test((value, context) => validateMaxValue(value, context, 'Quarterly'))
    .required(REQUIRED_FIELD),

  Monthly: number()
    .typeError(MUST_BE_NUMBER)
    .min(0, minValueMessage)
    .integer(MUST_BE_INTEGER)
    .test((value, context) => validateMaxValue(value, context, 'Monthly'))
    .required(REQUIRED_FIELD),
});
